import React from 'react';
import { useInViewAnimation } from '../hooks/useInViewAnimation';
import { Button } from './Button';

const industries = [
  'Manufacturing', 'Healthcare', 'Construction', 'Facility Management',
  'Retail', 'Real Estate', 'Hospitality', 'Education', 'Finance',
  'Government', 'Logistics'
];

export function IndustriesStrip() {
  const { ref, isInView } = useInViewAnimation();

  return (
    <section
      ref={ref}
      data-testid="industries-strip"
      className="max-w-[1200px] mx-auto px-6 py-16 md:py-20"
    >
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-10 md:mb-12">
        <h2
          className={`text-[32px] md:text-[40px] lg:text-[44px] leading-[1.1] text-[#0D212C] tracking-tight ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
          style={{ animationDelay: '0.05s' }}
        >
          Industries <span className="font-serif grad-text">we serve</span>
        </h2>
        <Button to="/industries" variant="secondary" className="!py-2 !px-5 text-sm">
          Explore industries
        </Button>
      </div>

      <div className="flex flex-wrap gap-3">
        {industries.map((name, i) => (
          <div
            key={name}
            data-testid={`industry-chip-${i}`}
            className={`rounded-full border border-[#7C3AED]/15 bg-white px-5 py-3 text-sm text-[#0D212C] hover:bg-gradient-to-r hover:from-[#051A24] hover:to-[#6D28D9] hover:text-white hover:border-transparent hover:shadow-[0_8px_24px_rgba(109,40,217,0.25)] transition-all ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
            style={{ animationDelay: `${0.08 + i * 0.04}s` }}
          >
            {name}
          </div>
        ))}
      </div>
    </section>
  );
}
